module.exports = __webpack_public_path__ + "static/media/fundo2_logo.098b83e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundo2_logo.png
// module id = 459
// module chunks = 0